'use client';

import { useEffect, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import logo from '/public/images/BEI_Logo_Industria_Horizontal_White 1.png';
import NavBar from './NavBar';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100); // Adjust threshold as needed
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`fixed top-0 z-50 flex w-full min-w-[200px] flex-row items-center justify-center bg-black/75 transition-all duration-300 lg:justify-between lg:px-20 ${
        isScrolled ? 'bg-black/100 py-2 shadow-md' : 'py-8'
      }`}
    >
      <div className="flex items-center justify-center lg:justify-start">
        <Link href="/" className="">
          <Image
            src={logo}
            alt={'Brittain Electric Logo'}
            width={268}
            height={71}
            priority
            className="h-auto w-44 sm:w-52 lg:w-[268px]"
          ></Image>
        </Link>
      </div>

      <NavBar />
    </div>
  );
};

export default Header;
